import { useGetWaitingListTicketsQuery } from "@/services/LiveQueueService";
import { useSelector } from "react-redux";
import { RootState } from "@/app/store";
import { TicketStatus } from "@/services/LiveQueueService";

export const useWaitingList = (eventId?: number) => {
  const userInfo = useSelector((state: RootState) => state.auth.userInfo);
  const today = new Date();
  const localDate = today.toLocaleDateString("en-CA"); //
  const queryParams = new URLSearchParams({
    dept_tag_id: userInfo?.department_id?.toString() ?? "0",
    counter_id: userInfo?.counter_id?.toString() ?? "0",
    date_filter: localDate, // Today's date
    sort_by: "rerouted_at", // Sort by rerouted_at
    sort_order: "asc",
    ...(eventId && { event_id: eventId.toString() }),
  });

  // rerouting_sort:"true"

  // Append multiple status values
  queryParams.append("status", TicketStatus.HOLD);
  queryParams.append("status", TicketStatus.NEW);
  queryParams.append("status", TicketStatus.CHECKED_IN);

  const query = queryParams.toString();

  const { data, isLoading, isError, error, refetch } =
    useGetWaitingListTicketsQuery(
      { query: queryParams.toString() },
      { refetchOnMountOrArgChange: true }
    );

  return {
    waitingList: data,
    isLoading,
    isError,
    error,
    refetchWaitingList: refetch,
  };
};
